import React, { FunctionComponent, memo } from "react";

import { createHashStateHook } from "../../../stores/useHashState";
import { Dialog } from "../../../ui/Dialog/Dialog";
import { Header } from "./Header";
import { TireComparisonGrid } from "./TireComparisonGrid";
import { useTireCompareIdsWithFallback } from "./useTireCompareIds";

export const compareTiresHash = "#compare-tires";
export const useCompareHash = createHashStateHook(compareTiresHash);

const Uncached: FunctionComponent = () => {
  const [hash, { hide }] = useCompareHash();
  const [compareIds] = useTireCompareIdsWithFallback();
  return (
    <Dialog
      className="w-full p-4 md:p-8 bg-body"
      id="tire-compare-dialog"
      onClose={hide}
      placement="top"
      visible={hash}
    >
      <Header compareIds={compareIds} />
      <TireComparisonGrid compareIds={compareIds} printMode={false} />
    </Dialog>
  );
};

export const TiresCompareDialog = memo(Uncached);
